export const HASH_PARAM_NAME = 'hash'

export const STORE: {
  access_token: 'access_token'
  validateRequest: 'validateRequest'
} = {
  access_token: 'access_token',
  validateRequest: 'validateRequest',
}
